
import { defineComponent, computed, reactive, watch } from "vue";
import BaseSection from "@/components/base/BaseSection.vue";
import BaseInput from "@/components/base/BaseInput.vue";
import BaseDropdown from "@/components/base/BaseDropdown.vue";
import BaseRadio from "@/components/base/BaseRadio.vue";
import BaseCheckbox from "@/components/base/BaseCheckbox.vue";
import { required, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import { DropdownOption } from "@/models/DropdownOption";
import { useAdditionalInfoStore } from "@/store/additionalInfo";

export default defineComponent({
	components: {
		BaseSection,
		BaseInput,
		BaseDropdown,
		BaseRadio,
		BaseCheckbox,
	},
	setup() {
		const store = useAdditionalInfoStore();
		const accomodationAreaOptions = [
			{ value: "St Marys", label: "St Mary's" },
			{ value: "Tresco", label: "Tresco" },
			{ value: "Bryher", label: "Bryher" },
			{ value: "St Martins", label: "St Martin's" },
			{ value: "St Agnes", label: "St Agnes" },
			{ value: "undecided", label: "Undecided" }
		] as DropdownOption[];

		const numberOfVisitsOptions = [
			{ value: "1", label: "This is my first time" },
			{ value: "2-3", label: "2-3" },
			{ value: "4-5", label: "4-5" },
			{ value: "6+", label: "6+" },
			{ value: "resident", label: "I'm a resident" },
		] as DropdownOption[];

		const initialState = store.getState;
		const state = reactive({
			accomodationName: initialState.accomodationName,
			accomodationArea: initialState.accomodationArea,
			numberOfVisits: initialState.numberOfVisits,
			notBookedAccommodation: false
		});

		const rules = {
			accomodationName: {
				v: helpers.withMessage(
					() => "Value is required",
					(value: string) => isResident.value === true || 
														 value.length > 0 || 
														 state.notBookedAccommodation === true
				),
			},
			accomodationArea: { 
				v: helpers.withMessage(
					() => "Value is required",
					(value: string) => isResident.value === true || value.length > 0
				),
			},
			numberOfVisits: { required },
			notBookedAccommodation: { },
		};

		const v$ = useVuelidate(rules, state);

		watch(state, () => {
			store.setState(state);
		});
		
		const isResident = computed(() => {
			return state.numberOfVisits === 'resident';
		});
		
		const notBookedAccommodation = computed(() => {
				return state.notBookedAccommodation;
		});
		
		return { v$, accomodationAreaOptions, numberOfVisitsOptions, isResident, notBookedAccommodation };
	},
});
